import { useCurrentUser } from "../../hooks/useGetUserDetail";
import { PROFILE_TYPE } from "../../utils/constants";
import appHeaderLogo from "../../assets/Icons/appHeaderLogo.png";
import appIcon from "../../assets/Icons/appIcon.png";
import workspaceIcon from "../../assets/Icons/workspace.png";
import { trackEvent } from "../../mixpanel";
import { MIXPANEL_EVENTS } from "../../mixpanel/events";
import "./RoleSelect.scss";

interface RoleSelectProps {
  setIsAuthenticated: (value: boolean) => void;
}

function RoleSelect({ setIsAuthenticated }: RoleSelectProps) {
  const { data: userInfo, loading } = useCurrentUser();

  const profileType = userInfo?.profileType?.toLowerCase();
  const isSuperAdmin = profileType === PROFILE_TYPE.SUPER_ADMIN;
  const isAdmin = profileType === PROFILE_TYPE.ADMIN;
  const hasAdminAccess = isSuperAdmin || isAdmin;

  // Derive a friendly first name — fall back gracefully
  const rawName: string =
    userInfo?.firstName ||
    userInfo?.name ||
    userInfo?.fullName ||
    userInfo?.userName ||
    "";
  const firstName = rawName.trim().split(/\s+/)[0] || "Teacher";

  // ── Troo stories → Admin dashboard (stories now run from the workspace)
  const handleStoriesSelect = () => {
    trackEvent(MIXPANEL_EVENTS.STORY_SESSION_SELECTED);
    localStorage.setItem("selectedMode", "admin");
    setIsAuthenticated(true);
  };

  // ── My workspace → Admin/SuperAdmin dashboard
  const handleWorkspaceSelect = () => {
    trackEvent(MIXPANEL_EVENTS.WORKSPACE_SELECTED);
    localStorage.setItem("selectedMode", "admin");
    setIsAuthenticated(true);
  };

  return (
    <div className="role-select">
      <div className="role-select__header">
        <img
          src={appHeaderLogo}
          alt="Troo by Yeti My Friend"
          className="role-select__header-logo"
        />
      </div>

      <h1 className="role-select__welcome">Welcome back, {firstName}!</h1>
      <p className="role-select__prompt">What would you like to do today?</p>

      <div className="role-select__cards">
        {/* Troo stories → Admin dashboard */}
        <div className="role-card">
          <img src={appIcon} alt="" className="role-card__icon" />
          <h2 className="role-card__title">Troo stories</h2>
          <button
            type="button"
            className="role-card__cta role-card__cta--purple"
            onClick={handleStoriesSelect}
            disabled={loading}
          >
            Start a session <span className="role-card__cta-arrow">→</span>
          </button>
        </div>

        {/* My workspace → Admin/SuperAdmin */}
        {hasAdminAccess && (
          <div className="role-card">
            <img src={workspaceIcon} alt="" className="role-card__icon" />
            <h2 className="role-card__title">My workspace</h2>
            <button
              type="button"
              className="role-card__cta role-card__cta--green"
              onClick={handleWorkspaceSelect}
              disabled={loading}
            >
              Start planning<span className="role-card__cta-arrow">→</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default RoleSelect;
